import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Avatar,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import getInitials from "../../utils/getInitials";
import { ZoneSetListResponse } from "../../api/zoneSet";
import { Loadable } from "../Loading/Loadable";
import formatDate from "../../utils/formatDate";
import LoadingWrapper from "../Loading/LoadingWrapper";
import LoadingTableRow from "../Loading/LoadingTableRow";

/** Props for the ZoneSetListResults component */
interface ZoneSetListResultsProps {
  /** List of rate sets that will be displayed in the list */
  zoneSetsResponse: Loadable<ZoneSetListResponse>;
  /** Function to execute when a rate set entry is clicked */
  onClick: (zoneSetId: string) => void;
}

const ZoneSetListResults = ({
  zoneSetsResponse,
  onClick,
  children,
  ...rest
}: React.PropsWithChildren<ZoneSetListResultsProps>) => {
  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Date Created</TableCell>
                <TableCell>Date Updated</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <LoadingWrapper
                loadingInfo={zoneSetsResponse}
                loadingComponent={<LoadingTableRow colSpan={4} />}
              >
                {zoneSetsResponse?.data?.zone_sets?.map((zoneSet) => (
                  <TableRow
                    hover
                    key={zoneSet.external_id}
                    onClick={() => onClick(zoneSet.external_id)}
                  >
                    <TableCell>
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <Avatar src={""} sx={{ mr: 2 }}>
                          {getInitials(zoneSet.name)}
                        </Avatar>
                        <Typography color="textPrimary" variant="body1">
                          {zoneSet.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{zoneSet.description}</TableCell>
                    <TableCell>
                      {formatDate(zoneSet.created_date_utc)}
                    </TableCell>
                    <TableCell>
                      {formatDate(zoneSet.last_modified_date_utc)}
                    </TableCell>
                  </TableRow>
                ))}
              </LoadingWrapper>
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      {children}
    </Card>
  );
};

export default ZoneSetListResults;
